import React from 'react';

// shared header for every settings tab so titles line up and each gets a subtitle
function SettingsHeader({ title, subtitle, actions }) {
  return (
    <div className="flex items-center justify-between gap-3 min-h-[38px] flex-shrink-0">
      <div className="flex items-baseline gap-3">
        <h2 className="text-lg font-semibold text-surface-800">{title}</h2>
        {subtitle && (
          <span className="text-sm text-surface-400 pl-3 border-l border-surface-200">
            {subtitle}
          </span>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export default SettingsHeader;
